// extracted by mini-css-extract-plugin
export default {"appShell":"App_appShell__6IFUn","pageFrame":"App_pageFrame__yb3qW","pageContent":"App_pageContent__S6r43"};